import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";
import FramedPhoto from "@/components/FramedPhoto";
import CtaSection from "@/components/CtaSection";
import { ABOUT_VALUES } from "@/data/site";

export default function About() {
  return (
    <>
      <Seo
        title="About Authentically Yours | Property Services Greensboro NC"
        description="Locally owned property services in Greensboro, NC built on reliability, professionalism, and personal attention. Meet the people behind Authentically Yours."
        path="/about"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "About Us", path: "/about" },
        ]}
      />
      <PageHero
        eyebrow="About Us"
        title="Professional Property Care With a Personal Touch"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "About Us", path: "/about" },
        ]}
      />

      <section className="container-x py-20 sm:py-28 grid lg:grid-cols-2 gap-14 items-start">
        <Reveal>
          <div className="relative max-w-md lg:sticky lg:top-28">
            <div className="absolute -inset-3 border border-gold/25" aria-hidden="true" />
            <FramedPhoto
              src="/assets/cleaning/window.webp"
              alt="Cleaner wiping an interior window to a streak-free shine"
              aspect="4 / 5"
              className="relative"
              testId="about-owner-graphic"
            />
            <p className="mt-6 font-serif text-2xl text-ink">Kiarah Ayers &amp; Daryl Thomas</p>
            <p className="eyebrow text-rose mt-1">Co-Owners</p>
          </div>
        </Reveal>

        <div className="space-y-6 text-ink/75 leading-relaxed text-lg max-w-xl">
          <p>
            Authentically Yours Property Services LLC is a locally owned company
            founded by <span className="text-ink font-medium">Kiarah Ayers</span> and{" "}
            <span className="text-ink font-medium">Daryl Thomas</span>, built around
            the belief that dependable property services should feel professional,
            straightforward, and personal.
          </p>
          <p>
            As hands-on owners, we're personally invested in the quality and care
            behind every job. Kiarah brings professional experience in property
            management, giving her a firsthand understanding of property turnovers,
            vendor expectations, deadlines, resident and customer service, and the
            standards property professionals rely on. That perspective shapes how we
            work — whether we're refreshing a family's home or helping a property
            manager get a unit ready for its next resident.
          </p>
          <p>
            We understand that inviting someone into your home, business, rental
            property, or community requires trust. That's why we focus not only on
            the work itself, but also on clear communication, reliability, and
            treating each property with respect — building long-term relationships
            with both residential customers and property professionals along the way.
          </p>
        </div>
      </section>

      <section className="bg-blush-soft/50 border-y border-gold/15">
        <div className="container-x py-20 sm:py-28">
          <SectionHeading eyebrow="Our Values" title="What Matters to Us" as="h2" />
          <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {ABOUT_VALUES.map((v, i) => (
              <Reveal key={v} delay={i * 0.05}>
                <div className="flex items-center gap-4 bg-white border border-gold/20 px-7 py-6">
                  <span className="font-serif text-2xl text-rose w-8 shrink-0">{String(i + 1).padStart(2, "0")}</span>
                  <span className="font-serif text-2xl text-ink">{v}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaSection />
    </>
  );
}
